import { render } from "./MultipleSelectConfig.vue?vue&type=template&id=32259e7e&scoped=true&ts=true"
import script from "./MultipleSelectConfig.vue?vue&type=script&lang=ts"
export * from "./MultipleSelectConfig.vue?vue&type=script&lang=ts"

import "./MultipleSelectConfig.vue?vue&type=style&index=0&id=32259e7e&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32259e7e"]])

export default __exports__